import { newsletterTemplate4Styling } from "@made-people/blueprint-newsletter-signup/blueprint";

newsletterTemplate4Styling.main.override({
  slots: {
    background: "",
    wrapper:
      "overflow-hidden flex flex-col lg:pt-12 lg:pt-0 lg:row-start-2 lg:col-start-10 lg:col-end-13",
    container: "flex flex-col gap-5",
    headingWrapper: "flex flex-col items-start gap-3 justify-center w-full",
    heading:
      "text-label-md font-medium lg:text-heading-sm font-primary text-balance",
    body: "text-body-sm lg:text-body-md font-bold lg:font-bold",
    formWrapper: "block w-full",
    form: "flex flex-col gap-3",
    fieldsWrapper: "relative flex flex-col gap-2 text-black",
    buttonWrapper: "w-full",
    image: "hidden",
  },
});

newsletterTemplate4Styling.inputField.override({
  slots: {
    inputWrapper:
      "w-full h-full relative flex flex-col items-left gap-1 text-black ",
    inputLabel: "absolute h-full w-full capitalize text-text-less-emphasis-2",
    inputField:
      "rounded w-full placeholder:text-text-less-emphasis-1 lg:text-sm border-none focus:outline-none border-transparent bg-transparent px-4 py-2 h-12 autofill:bg-transparent autofill:shadow-[inset_0_0_0px_1000px_rgb(255,255,255)] bg-white rounded border border-black/10",
    inputError: "text-body-xs text-system-error",
  },
});

newsletterTemplate4Styling.termsAndConditions.override({
  slots: {
    termsAndConditionsWrapper: "flex flex-row gap-2 items-start text-body-xs",
    termsAndConditionsBody:
      "[&>span>p>a]:underline [&>span>p>a]:underline-offset-2",
    checkbox:
      "flex h-4 w-4 items-center justify-center bg-white rounded-sm shrink-0",
    checkboxIndicator: "stroke-black",
  },
});
